import React from "react";
import { Modal, Box, Typography, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 3,
};

const NotificationModal = ({ open, handleClose, notifications }) => {
  if (!open) return null;

  const notificationList = Array.isArray(notifications)
    ? notifications
    : notifications
      ? Object.values(notifications)
      : [];

  const sortedNotifications = notificationList.sort(
    (a, b) => (b.createdAt || 0) - (a.createdAt || 0)
  );

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton onClick={handleClose} sx={{ position: "absolute", top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" gutterBottom>
          Notifications
        </Typography>

        <Box
          sx={{
            maxHeight: "50vh",
            overflowY: "auto",
            pr: 1,
          }}
        >
          {sortedNotifications.length === 0 ? (
            <Typography>No Notifications Found.</Typography>
          ) : (
            sortedNotifications.map((item, index) => (
              <Box key={index} mb={2}>
                <Typography fontWeight="bold">{item?.title || "No Title"}</Typography>

                <Typography variant="caption" color="text.secondary">
                  {item?.createdAt ? new Date(item.createdAt).toLocaleString() : "No Time"}
                </Typography>

                <Typography mt={1} fontSize="14px">
                  {item?.text || "No Description"}
                </Typography>

                {index !== sortedNotifications.length - 1 && <Divider sx={{ mt: 2 }} />}
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default NotificationModal;
